import { render, staticRenderFns } from "./CardMember.vue?vue&type=template&id=2460f2f8&scoped=true"
import script from "./CardMember.vue?vue&type=script&lang=js"
export * from "./CardMember.vue?vue&type=script&lang=js"
import style0 from "./CardMember.vue?vue&type=style&index=0&id=2460f2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2460f2f8",
  null
  
)

export default component.exports